import { Navigate, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectRefLoginCompleteToken } from "../redux/slices/referralSlice.slice";

import UserLogin from "../components/auth/user-login";
import OtpScreen from "../components/auth/otp";
import NewPassword from "../components/auth/new-password";
import SubscriptionScreen from "../components/SubscriptionnScreen";
import PaymentScreen from "../components/SubscriptionnScreen/paymentSummary";

const RequireReferralAuth = ({ children }) => {
  const refLoginCompleteToken = useSelector(selectRefLoginCompleteToken);

  if (!refLoginCompleteToken) {
    return <Navigate to="/userlogin" replace />;
  }

  return children;
};

const RefRoute = () => {
  const refLoginCompleteToken = useSelector(selectRefLoginCompleteToken);

  return (
    <Routes>
      {/* Entry point */}
      <Route
        path="/"
        element={
          <Navigate
            to={
              refLoginCompleteToken?.length > 0
                ? "/subscriptionScreen"
                : "/userlogin"
            }
            replace
          />
        }
      />

      {/* Referral onboarding (NO GUARD) */}
      <Route path="/userlogin" element={<UserLogin />} />
      <Route path="/otp" element={<OtpScreen />} />
      <Route path="/createnewpassword" element={<NewPassword />} />

      {/* Post-referral protected */}
      <Route
        path="/subscriptionScreen"
        element={
          <RequireReferralAuth>
            <SubscriptionScreen />
          </RequireReferralAuth>
        }
      />
      <Route
        path="/paymentSummary"
        element={
          <RequireReferralAuth>
            <PaymentScreen />
          </RequireReferralAuth>
        }
      />
    </Routes>
  );
};

export default RefRoute;
